import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import Sidebar from '../Sidebar';
import AppHeader from '../AppHeader';

const SIDEBAR_FULL = 260;
const SIDEBAR_COLLAPSED = 72;

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const sidebarWidth = collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_FULL;

  return (
    <div className="flex min-h-screen bg-surface-tertiary font-inter">
      <Sidebar
        collapsed={collapsed}
        onCollapse={setCollapsed}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <div
        className="hidden lg:block shrink-0 transition-all duration-200"
        style={{ width: sidebarWidth }}
      />

      <div className="flex-1 min-w-0 flex flex-col max-h-screen overflow-hidden">
        <AppHeader
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed((c) => !c)}
          onMobileMenuOpen={() => setMobileOpen(true)}
        />

        <main
          className="flex-1 overflow-y-auto"
          style={{ padding: '24px 24px 48px', scrollbarGutter: 'stable' }}
        >
          <div className="max-w-screen-2xl mx-auto page-enter">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
